import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IProfileSearchBody, IProfileSearchResult, IProfileSearchResultRecord } from '@assess/shared/data-mart-search';

import { SearchService } from './search.service';

@Injectable({ providedIn: 'root' })
export class ProfileSearchService {
  private readonly resourceType = 'profile';

  constructor(private readonly searchService: SearchService) {}

  search(body: Partial<IProfileSearchBody>): Observable<IProfileSearchResult> {
    return this.searchService.search<IProfileSearchResultRecord>(this.resourceType, body);
  }
}
